//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Input',
  data() {
    return {
      currentValue: this.value,
      imageSrc:null
    };
  },
  props: {
    value: {
      type: [String],
      default: ''
    },
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    }
  },
  methods: {
    getImage() {
      this.imageSrc = process.env.API_ROOT + 'api/code/image/?' + new Date().getTime();
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    inputload(event){
      let value = event;
      this.$emit('input', value)
    }
  },
  mounted(){
    this.getImage();
  }
}



// WEBPACK FOOTER //
// ./src/components/validate-code.vue